import React from 'react'

import HeaderMeta from 'components/HeaderMeta'

import Content, { Theme as ContentTheme } from 'components/base/Content'
import Title from 'components/base/Title'
import Paragraph from 'components/base/Paragraph'
import Link, { Theme as LinkTheme } from 'components/base/Link'
import { ConnectIconMic } from 'components/base/Icon/styles'

import PageHero, { Theme as PageHeroTheme } from 'components/blocks/PageHero'
import Leadership from 'components/blocks/Leadership'
import OurStory from 'components/blocks/OurStory'
import NewsItem from 'components/blocks/NewsItem'
import Card, { Bg as CardBg } from 'components/blocks/Card'

import Connect from 'components/blocks/Connect'


const NewsScreen: React.FC = (): React.ReactElement => (
  <div>
    <HeaderMeta
      title='Company News | Insurance Lounge'
      description='Stay updated on new Insurance Lounge locations, changes to our offerings, and more.'
      ogImg='/images/og-images/News.webp'
    />
    <PageHero theme={PageHeroTheme.news}>News</PageHero>
    <Content margined={true}>
      <Content theme={ContentTheme.flex} large={true}>
        <Card bg={CardBg.two}>
          <NewsItem
            source='Press Release'
            title='Insurance Lounge Raises $15M Growth Equity to Fuel Rapid Expansion'
            linkUrl='/about-us/press/insurance-lounge-raises-15-million'
          />
        </Card>
        <Card bg={CardBg.one}>
          <NewsItem
            source='Agency Revolution'
            title='Insurance Lounge CEO Michael DeLaGrange Featured in Agency Revolution Podcast'
            linkUrl='https://www.agencyrevolution.com/blog/podcast/michael-delagrange-founder-president-of-insurance-lounge/'
          />
        </Card>
        <Card bg={CardBg.two}>
          <NewsItem
            source='Stitcher.com'
            title='Insurance Lounge Founder & CEO Featured on The Standout Millennial Show'
            linkUrl='https://www.stitcher.com/podcast/the-standout-millennial-show?fbclid=IwAR2Dv7Jqn0c59ETDM8Q8U8pRAcKy2K5jYJbDcpv9nTHJ65ghbKxQDSlsIBM'
          />
        </Card>
        <Card bg={CardBg.two}>
          <NewsItem
            source='Lake Oswego Review'
            title='Insurance Lounge Makes Buying Insurance Fun'
            linkUrl='https://pamplinmedia.com/lor/106-business/263067-134774-insurance-lounge-makes-buying-insurance-fun-interesting'
          />
        </Card>
        <Card bg={CardBg.one}>
          <NewsItem
            source='BetterBusinessBureau.com'
            title='Insurance Lounge Trusted on Better Business Bureau'
            linkUrl='https://www.bbb.org/us/or/portland/profile/insurance/insurance-lounge-beaverton-llc-1296-1000051193'
          />
        </Card>
        <Card bg={CardBg.one}>
          <NewsItem
            source='The Rogue Valley Messenger'
            title='Unveiling Talent: Art Event at Insurance Lounge'
            linkUrl='http://www.roguevalleymessenger.com/unveiling-talent-the-ryan-moon-gallery-event-at-insurance-lounge/'
          />
        </Card>
        <Card bg={CardBg.four}>
          <NewsItem
            source='FlashAlert.net'
            title='Grant-funded community groups and insurance agents get set to help Oregonians enroll in health coverage'
            linkUrl='https://flashalert.net/id/ODCBS/126812'
          />
        </Card>
        <Card bg={CardBg.two}>
          <NewsItem
            source='KZTV'
            title='Grants to groups, insurance agents to help enroll in coverage'
            linkUrl='https://www.ktvz.com/news/grants-to-groups-insurance-agents-to-help-enroll-in-coverage/793526937'
          />
        </Card>
        <Card bg={CardBg.one}>
          <NewsItem
            source='SmallBizTrends.com'
            title='15 Top Insurance Franchise Business Opportunities in the US'
            linkUrl='https://smallbiztrends.com/2019/03/insurance-franchise.html'
          />
        </Card>
      </Content>
      <Content short={true} center={true} margined={true}>
        <Title level={2}>Questions About Insurance Lounge?</Title>
        <ConnectIconMic />
        <Title level={4}>Visit Our Press Center</Title>
        <Paragraph>
          <Link theme={LinkTheme.button} to='/about-us/press/'>
            Press Center
          </Link>
        </Paragraph>
      </Content>
    </Content>
    <Leadership />
    <OurStory />
    <Connect
      trackingInfo={{
        button_position: 'bottom',
        page_category: 'about_us',
      }}
    />
  </div>
)

export default NewsScreen
